import React from 'react'
import { useTheme } from 'react-jss'
import { IkonSammenlaeg } from '../../../../assets/icons'
import { CaseDetail } from '../../../../models/CaseDetail'
import { useStyles } from '../../../ui/Card/CardColumn'
import { Typography } from '../../../ui/Typography/Typography'
import { colors } from '../../../../theme/palette'
import { Circle, CircleIcon } from '../../../ui/Circle/Circle'
import MergedCasesOverlay from './MergedCasesOverlay'
import { L } from '../../../providers/Lokalise'

export type MergedCasesRowProps = {
    caseDetails: CaseDetail
    onUpdated?: () => void
}

const MergedCasesRow: React.FC<MergedCasesRowProps> = ({
    caseDetails,
    onUpdated,
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = useStyles({ ...{ gridTemplateColumns: '1fr' }, theme })

    return (
        <>
            <div className={classes.column}>
                <div className={classes.titleContainer}>
                    <Circle>
                        <CircleIcon iconWidth="1.4rem">
                            <IkonSammenlaeg fill={colors.green500} />
                        </CircleIcon>
                    </Circle>

                    <Typography
                        tag="h3"
                        size="XXS"
                        spacing=".2rem"
                        style={{ flexGrow: 1 }}
                    >
                        {`${L(
                            'LØN_OVERSIGT_SAMMENLAG_SAGER_CONTAINER_KNAP'
                        )} (${caseDetails?.mergedCaseList?.length ?? 0})`}
                    </Typography>
                    <MergedCasesOverlay
                        caseDetails={caseDetails}
                        onUpdated={() => {
                            onUpdated?.()
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export { MergedCasesRow }
